import React from 'react';
import { Modal } from 'react-bootstrap';

class WaitlistSuccessModal extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      showModal: true
    }

    this.close = this.close.bind(this);
  }

  componentWillMount() {
    this.props.fetchUserCount();
    this.props.addToUserCount();
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    return (
      <Modal className='waitlist-success-modal' show={this.state.showModal} onHide={this.close}>
        <div className="modal-header">
          <h5 className="modal-title">Thank you!</h5>
          <button type="button" className="close" onClick={this.close}>
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close</span>
          </button>
        </div>

        <Modal.Body>
          <div className='waitlist-count-container'>
            <div className='waitlist-email'>
              {(this.props.waitlistEmail + ' has'|| 'You\'ve') + " joined the waitlist!"}
            </div>
            <div className='waitlist-count'>
              {"There are " + (this.props.waitlistCount || '') + " people ahead of you"}
            </div>

            <hr />
            <div className='waitlist-share-title'> Want faster access?  </div>
            <div className='waitlist-share-message'> Help us build our community faster by sharing with friends and family! </div>
          </div>

        </Modal.Body>

        <div className="share-button-container">
          <a className="twitter-hashtag-button"
          href="https://twitter.com/intent/tweet?button_hashtag=storage&ref_src=twsrc%5Etfw"
          data-size="large"
          data-text="Checkout next revolution in self storage"
          data-url="http://www.tinbin.io"
          data-lang="en"
          data-show-count="false">Tweet</a>
          <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>

          <div className="fb-share-button"
            data-href="http://www.tinbin.io"
            data-layout="button"
            data-size="large"
            data-mobile-iframe="true">
            <a className="fb-xfbml-parse-ignore"
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fwww.tohbo.com%2F&amp;src=sdkpreparse">Share</a>
          </div>
        </div>
      </Modal>
    );
  }
}

export default WaitlistSuccessModal;



// WEBPACK FOOTER //
// ./src/views/components/waitlist/waitlist_success_modal.jsx